import { useContext, useEffect, useRef, useState } from "react";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { BodyContainerP5, ButtonScan, ContainerP5 } from "./localStyle";
import { BarcodeScanner } from "@capacitor-community/barcode-scanner";
import QRIcon from "_+_Portal/assets/images/generico/QRIcon";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";

const EscaneoQR = () => {
  //#region --------- context ---------------
  const { toasterDispatch } = useContext(GlobalContext);
  const { pasoDispatch } = useContext(AutocheckContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const contentRef = useRef(null);
  const [scannedData, setScannedData] = useState(null);
  const [startedScan, setStartedScan] = useState(false);
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };

  const startScan = async () => {
    // Pedimos permiso
    const status = await BarcodeScanner.checkPermission({ force: true });

    // if (!status.granted) {
    //   alert("Permiso de cámara denegado");
    //   return;
    // }

    // Ocultamos el fondo de la app (opcional)
    BarcodeScanner.hideBackground();
    setStartedScan(true);
    contentRef.current?.classList.add("scanner-active");

    const result = await BarcodeScanner.startScan({
      cameraDirection: "back", // Esto fuerza la cámara trasera
    }); // Activa cámara

    BarcodeScanner.showBackground();
    contentRef.current?.classList.remove("scanner-active");

    if (result.hasContent) {
      setScannedData(result.content || null);
      sessionStorage.setItem("centroID", result.content);
      setStartedScan(false);
    }
  };
  //#endregion --------- funciones ---------------

  //#region  ----------- useEffects ---------------
  useEffect(() => {
    if (scannedData !== null) {
      showToaster(
        {
          texto: "Centro escaneado correctamente.",
          tipo: "success",
        },
        "centroArriba",
      )(toasterDispatch);
      if (pasoDispatch?.paso?.anterior === "AtencionSinTurnoSelect") {
        setPaso("DemandaEspontanea")(pasoDispatch);
      } else {
        setPaso("OrdenesDigitales")(pasoDispatch);
      }
    }
  }, [scannedData, pasoDispatch?.paso?.anterior]);

  useEffect(() => {
    return () => {
      BarcodeScanner.showBackground();
      BarcodeScanner.stopScan();
    };
  }, []);
  //#endregion --------- useEffects ---------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin"}
      handleClick={volver}
      title={"Escanear QR"}
      hideLogo={startedScan}
    >
      <ContainerP5
        initial={{ opacity: 0, y: +100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <BodyContainerP5>
          {!startedScan && (
            <>
              <p className="txtQR">
                Para continuar con el proceso necesitamos que escanees el código
                QR, acerca la cámara de tu dispositivo al QR más cercano
              </p>
              <QRIcon color={"var(--color-latex10)"} />
              <ButtonScan onClick={startScan}>Escanear QR</ButtonScan>
              {scannedData && (
                <p style={{ padding: "1rem", textAlign: "center" }}>
                  <strong>Resultado:</strong> {scannedData}
                </p>
              )}
            </>
          )}
        </BodyContainerP5>
      </ContainerP5>
    </LayoutPasos>
  );
};

export default EscaneoQR;
